import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { AddIcon, CircleCheckmarkIcon, CloseIcon } from '@treams/treams-icons';
import { Button } from '@treams/treams-ui';

export default function OptIn({
	joined,
	loading,
	disabled,
	onClick,
}: {
	joined: boolean;
	loading?: boolean;
	disabled?: boolean;
	onClick: () => void;
}) {
	const [isHovered, setIsHovered] = useState(false);
	const { t } = useTranslation();

	const type = joined ? (isHovered ? 'destructive' : 'primary') : 'secondary';
	const title = joined
		? isHovered
			? t('learning.event.rsvp.remove.button.title')
			: t('learning.event.rsvp.joined.button.title')
		: t('learning.event.rsvp.join.button.title');
	const icon = joined ? isHovered ? <CloseIcon /> : <CircleCheckmarkIcon /> : <AddIcon />;

	return (
		<Box
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<Button
				type={type}
				icon={icon}
				title={title}
				loading={loading}
				disabled={disabled}
				onClick={onClick}
			/>
		</Box>
	);
}
